import React, { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { API_URL } from "../constant";
import axiosInstance from "../utils/axiosConfig";
import { toast } from "react-hot-toast";
import { useAuth } from "../context/auth-context";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getDeviceInfo } from "../utils/deviceInfo";

const CodeScreen = ({ setCodeScreen, codeMail, codeOtp, setCodeOtp }: any) => {
  const [loading, setLoading] = useState(false);
  const { authenticate } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { from = "/dashboard" } = state || {};
  const deviceInformation = getDeviceInfo();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // removes non-digits
    setCodeOtp(value);
  };

  const signInWithAuthCode = async () => {
    try {
      setLoading(true);
      const payload: any = {
        email: codeMail,
        otp: codeOtp,
        password: "admin_123",
        deviceInfo: {
          name: deviceInformation.deviceName,
          uniqueId: deviceInformation.uniqueId,
          os: deviceInformation.operatingSystem?.family,
        },
        rolePass: "admin",
      };

      const res = await axiosInstance.post(
        `${API_URL}api/auth/complete-signin`,
        payload
      );

      toast.success("Login successful");
      setCodeOtp("");
      await authenticate();
      navigate(from);
    } catch (err: any) {
      toast.error(
        (err?.response?.data?.message as string) ||
          String(err?.message || "Login failed")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-center overflow-auto   bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="w-11/12 mds:w-2/3 lgss:w-[38%] xxl:w-[30%] transition-all p-6 ease-in duration-1000  rounded-xl bg-[#1F1F1F] ">
        <div className="flex  pt-4 justify-between items-center">
          <h4 className="font-bold text-[20px] font-sora text-white">
            Confirm transaction
          </h4>
          <h4
            onClick={() => setCodeScreen(false)}
            className="text-[#78C2F7] font-medium text-[14px] cursor-pointer"
          >
            Close
          </h4>
        </div>
        <div className="pt-6">
          <h4 className="text-[15px] text-[#A0A9AD] font-medium">
            Enter OTP sent to your email
          </h4>
          <div className="w-full mt-6">
            <label
              htmlFor=""
              className="text-white text-[14px] lgss:text-[14px] font-bold"
            >
              OTP
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={codeOtp}
              placeholder="Paste 6-digits code"
              onChange={handleChange}
              //   style={{ direction: "ltr", textAlign: "right" }}
              className="w-full spin-button-none text-[13px] lgss:text-[15px]  mt-2  text-[#A0A9AD] bg-[#1C2227] px-4 outline-none h-[48px] rounded-xl border border-[#141414]"
            />
          </div>

          <button
            onClick={() => signInWithAuthCode()}
            disabled={typeof codeOtp === "string" && codeOtp.length !== 6}
            className={
              typeof codeOtp === "string" && codeOtp.length !== 6
                ? " w-full rounded-xl py-3 flex justify-center items-center text-gray-200 text-[16px] font-bold mt-6 bg-gray-600"
                : " w-full rounded-xl py-3 flex justify-center items-center text-white text-[16px] font-bold mt-6 bg-secondary_button"
            }
          >
            {loading ? (
              <TailSpin color="#FFFFFF" height={30} width={30} />
            ) : (
              "Confirm"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CodeScreen;
